export enum AuthActionListEnum {
  LOGIN = 'auth:login',
  LOGOUT = 'auth:logout',
}
